import React, { useState } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

const SingleColumnLayout = ({ settings }) => {
  const { blocks, url, section } = settings;
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const [selectedTags, setSelectedTags]: any = useState([]);
  const show_all = false;

  const handleTagClick = (title, blockUrl, blockId) => {
    if (section.navigation_type === 'url' && blockUrl) {
      // Navigate to URL
      window.location.href = blockUrl;
    } else if (section.navigation_type === 'id' && blockId) {
      // Scroll to element with ID
      const element = document.getElementById(blockId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Handle filtering
      if (selectedTags.includes(title)) {
        setSelectedTags(selectedTags.filter((tag) => tag !== title));
      } else {
        setSelectedTags([title]);
      }
    }
  };

  const showTitle = false;

  const spacing = isMobile
    ? settings.section.padding_left_right_mobile
    : settings.section.padding_left_right_desktop

  return (
    <div x-data="blogfilters">
      {showTitle && <h4>Blog</h4>}

      <div className={`blog-filters flex justify-center pb-4 mt-6 -mr-[${spacing}px] pr-[${spacing}px]]`}>
        <ul className={`blog-filters__list text-nowrap`}>
            {show_all && <li
                className={`blog-filters__button button button-tertiary ${selectedTags.length === 0 && "selected"}`}
                onClick={() => {
                  if (section.navigation_type === 'url' && url) {
                    window.location.href = url;
                  } else {
                    setSelectedTags([]);
                  }
                }}
            >
                <div data-id={url}>All</div>
            </li>}

            {blocks.map((block, index) => (
              <li
                  key={index}
                  className={`min-w-[106px] blog-filters__button button button-tertiary ${selectedTags.includes(block.settings.title) && "selected"}`}
                  onClick={() => handleTagClick(block.settings.title, block.settings.url, block.settings.id)}
              >
                  <div data-id={block.settings.url}>{block.settings.title}</div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default SingleColumnLayout;
